import { isNotNullOrUndefined, isNumberNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class PaymentDetails {
    method = "OTHER"; // enum PaymentMethods

    payerName = null;
    payerCode = null;
    planName = null;
    planNumber = null;
    groupName = null;
    groupNumber = null;
    planType = null;
    policyType = null;
    subscriberId = null;

    rxBin = null;
    rxPcn = null;
    rxGroup = null;

    patientFirstName = null;
    patientLastName = null;

    subscriberFirstName = null;
    subscriberLastName = null;
    relationshipToSubscriber = 'MEMBER';

    expirationDate = null;
    state = null; // billing state
    postalCode = null; // billing postal code

    paymentMethodId = null;
    // vaultId stores the payment method identifier from the payment gateway:
    // - NMI: customer vault ID
    // - REVOLV3: paymentMethodId from REVOLV3 API
    // - Klarna: Klarna's payment method token
    vaultId = null;
    gateway = null;
    cardName = null; // name on card
    expirationDateMonth = null;
    expirationDateYear = null;
    cardType = null; // VISA, MASTERCARD, AMEX, etc
    lastFour = null; // last 4 digits of credit card
    processorId = null;
    initialTransactionId = null;

    // If there is more than one payment method on a subscription/order, then the payment method 
    // that is set to 100% will be charged last and get the remainder of the total order amount
    paymentAmount = 100.0; // default will be 100% as we assume there is only one payment method for an order/subscription. 
    paymentType = 'PERCENTAGE'; // 'PERCENTAGE' or 'FLAT_AMOUNT'

    constructor(paymentDetails) {
        if (isObjectNotEmpty(paymentDetails)) {
            if (isStringNotEmpty(paymentDetails.method)) { this.method = paymentDetails.method; }
            if (isStringNotEmpty(paymentDetails.payerName)) { this.payerName = paymentDetails.payerName; }
            if (isStringNotEmpty(paymentDetails.payerCode)) { this.payerCode = paymentDetails.payerCode; }
            if (isStringNotEmpty(paymentDetails.planName)) { this.planName = paymentDetails.planName; }
            if (isStringNotEmpty(paymentDetails.planNumber)) { this.planNumber = paymentDetails.planNumber; }
            if (isStringNotEmpty(paymentDetails.groupName)) { this.groupName = paymentDetails.groupName; }
            if (isStringNotEmpty(paymentDetails.groupNumber)) { this.groupNumber = paymentDetails.groupNumber; }
            if (isStringNotEmpty(paymentDetails.planType)) { this.planType = paymentDetails.planType; }
            if (isStringNotEmpty(paymentDetails.policyType)) { this.policyType = paymentDetails.policyType; }
            if (isStringNotEmpty(paymentDetails.subscriberId)) { this.subscriberId = paymentDetails.subscriberId; }

            if (isStringNotEmpty(paymentDetails.rxBin)) { this.rxBin = paymentDetails.rxBin; }
            if (isStringNotEmpty(paymentDetails.rxPcn)) { this.rxPcn = paymentDetails.rxPcn; }
            if (isStringNotEmpty(paymentDetails.rxGroup)) { this.rxGroup = paymentDetails.rxGroup; }

            if (isStringNotEmpty(paymentDetails.patientFirstName)) { this.patientFirstName = paymentDetails.patientFirstName; }
            if (isStringNotEmpty(paymentDetails.patientLastName)) { this.patientLastName = paymentDetails.patientLastName; }

            if (isStringNotEmpty(paymentDetails.subscriberFirstName)) { this.subscriberFirstName = paymentDetails.subscriberFirstName; }
            if (isStringNotEmpty(paymentDetails.subscriberLastName)) { this.subscriberLastName = paymentDetails.subscriberLastName; }
            if (isStringNotEmpty(paymentDetails.relationshipToSubscriber)) { this.relationshipToSubscriber = paymentDetails.relationshipToSubscriber; }

            if (isNotNullOrUndefined(paymentDetails.expirationDate)) { this.expirationDate = paymentDetails.expirationDate; }
            if (isStringNotEmpty(paymentDetails.state)) { this.state = paymentDetails.state; }
            if (isStringNotEmpty(paymentDetails.postalCode)) { this.postalCode = paymentDetails.postalCode; }

            if (isStringNotEmpty(paymentDetails.paymentMethodId)) { this.paymentMethodId = paymentDetails.paymentMethodId; }
            if (isStringNotEmpty(paymentDetails.vaultId)) { this.vaultId = paymentDetails.vaultId; }
            if (isStringNotEmpty(paymentDetails.gateway)) { this.gateway = paymentDetails.gateway; }
            if (isStringNotEmpty(paymentDetails.cardName)) { this.cardName = paymentDetails.cardName; }
            if (isStringNotEmpty(paymentDetails.expirationDateMonth)) { this.expirationDateMonth = paymentDetails.expirationDateMonth.trim(); }
            if (isStringNotEmpty(paymentDetails.expirationDateYear)) { this.expirationDateYear = paymentDetails.expirationDateYear.trim(); }
            if (isStringNotEmpty(paymentDetails.cardType)) { this.cardType = paymentDetails.cardType; }
            if (isStringNotEmpty(paymentDetails.lastFour)) { this.lastFour = paymentDetails.lastFour; }
            if (isStringNotEmpty(paymentDetails.processorId)) { this.processorId = paymentDetails.processorId; }
            if (isStringNotEmpty(paymentDetails.initialTransactionId)) { this.initialTransactionId = paymentDetails.initialTransactionId; }

            if (isNumberNotEmpty(paymentDetails.paymentAmount)) { this.paymentAmount = paymentDetails.paymentAmount; }
            if (isStringNotEmpty(paymentDetails.paymentType)) { this.paymentType = paymentDetails.paymentType; }
        }
    }

    toDto = () => {
        return {
            method: this.method,

            payerName: this.payerName,
            payerCode: this.payerCode,
            planName: this.planName,
            planNumber: this.planNumber,
            groupName: this.groupName,
            groupNumber: this.groupNumber,
            planType: this.planType,
            policyType: this.policyType,
            subscriberId: this.subscriberId,

            rxBin: this.rxBin,
            rxPcn: this.rxPcn,
            rxGroup: this.rxGroup,

            patientFirstName: this.patientFirstName,
            patientLastName: this.patientLastName,

            subscriberFirstName: this.subscriberFirstName,
            subscriberLastName: this.subscriberLastName,
            relationshipToSubscriber: this.relationshipToSubscriber,

            expirationDate: this.expirationDate,
            state: this.state,
            postalCode: this.postalCode,

            paymentMethodId: this.paymentMethodId,
            vaultId: this.vaultId,
            gateway: this.gateway,
            cardName: this.cardName,
            expirationDateMonth: this.expirationDateMonth,
            expirationDateYear: this.expirationDateYear,
            cardType: this.cardType,
            lastFour: this.lastFour,
            processorId: this.processorId,
            initialTransactionId: this.initialTransactionId,

            paymentAmount: this.paymentAmount,
            paymentType: this.paymentType
        };
    }
};

export default PaymentDetails;